
import {whenReady} from "../general/Util";
import LoginForm from './../general/Login.js';


const initQuickviewLogin = function() {

	const loginFormEls = document.querySelectorAll( '#details_container form.account_login' );
	loginFormEls.forEach( formEl => {
		LoginForm.initForm( formEl );
	} );
}

/*
**  Moved from productmain.tpl
*/
whenReady.then( () => {

	// Reinitialise on Variant Change.
	document.addEventListener( 'finished_change_variant', () => initQuickviewLogin() );
	initQuickviewLogin();
} );

export default initQuickviewLogin;
